export const fetcher = (url: string) =>
  fetch(url).then(async (res) => {
    if (res.status === 403) {
      const jsonError = await res.json();
      const error = new Error(jsonError.message ?? "Keine Berechtigung");
      // @ts-ignore
      error.status = 403;
      throw error;
    } else if (res.status >= 400) {
      const jsonError = await res.json();
      const error = new Error(
        jsonError.message ?? "Ein Fehler ist aufgetreten"
      );
      // @ts-ignore
      error.status = res.status;
      throw error;
    } else {
      return res.json();
    }
  });

export const postFetcher = (url: string, data?: any) =>
  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  }).then(async (res) => {
    if (res.status === 403) {
      const jsonError = await res.json();
      const error = new Error(jsonError.message ?? "Keine Berechtigung");
      // @ts-ignore
      error.status = 403;
      throw error;
    } else if (res.status >= 400) {
      const jsonError = await res.json();
      const error = new Error(
        jsonError.message ?? "Ein Fehler ist aufgetreten"
      );
      // @ts-ignore
      error.status = res.status;
      throw error;
    } else {
      return res.json();
    }
  });

export const deleteFetcher = (url: string, data: any) =>
  fetch(url, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  }).then(async (res) => {
    if (res.status === 403) {
      const jsonError = await res.json();
      const error = new Error(jsonError.message ?? "Keine Berechtigung");
      // @ts-ignore
      error.status = 403;
      throw error;
    } else if (res.status >= 400) {
      const jsonError = await res.json();
      const error = new Error(
        jsonError.message ?? "Ein Fehler ist aufgetreten"
      );
      // @ts-ignore
      error.status = res.status;
      throw error;
    } else {
      return res.json();
    }
  });
